// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface GetCompaniesEntryResponseDto
 */
export interface GetCompaniesEntryResponseDto {
    /**
     *
     * @type {string}
     * @memberof GetCompaniesEntryResponseDto
     */
    id: string;
    /**
     *
     * @type {string}
     * @memberof GetCompaniesEntryResponseDto
     */
    name: string;
    /**
     *
     * @type {number}
     * @memberof GetCompaniesEntryResponseDto
     */
    totalEntries: number;
}

/**
 * Check if a given object implements the GetCompaniesEntryResponseDto interface.
 */
export function instanceOfGetCompaniesEntryResponseDto(
    value: object,
): value is GetCompaniesEntryResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalEntries' in value) || value['totalEntries'] === undefined) return false;
    return true;
}

export function GetCompaniesEntryResponseDtoFromJSON(json: any): GetCompaniesEntryResponseDto {
    return GetCompaniesEntryResponseDtoFromJSONTyped(json, false);
}

export function GetCompaniesEntryResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): GetCompaniesEntryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        id: json['id'],
        name: json['name'],
        totalEntries: json['totalEntries'],
    };
}

export function GetCompaniesEntryResponseDtoToJSON(
    value?: GetCompaniesEntryResponseDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        id: value['id'],
        name: value['name'],
        totalEntries: value['totalEntries'],
    };
}
